import {
  isPage,
  applyThemeClass,
  cleanContent,
  moveWidgetsToMainContent,
  addMobileItem,
} from '../utils/helpers.js';
import { initWidgets } from './initWidgets.js';

export function foundationTheme() {
  const themeClassName = 'ese-foundation';
  const themeHomepageClassName = 'ese-foundation-home';

  if (isPage(themeClassName)) {
    applyThemeClass(themeClassName);
    addMobileItem({
      wrapperClass: 'donate-btn-container',
      linkClass: 'donate-btn-mobile',
      linkUrl: 'https://www.easternstatesexposition.com/p/foundation/donate1',
      linkLabel: 'Donate',
    });
    initWidgets();

    setTimeout(() => {
      $(`.${themeClassName}`).addClass('loaded');
    }, 1000);
  }

  if (isPage(themeHomepageClassName)) {
    $(globalThis).on('load', function () {
      $('#goog-gt-tt').remove();
    });
    cleanContent();
    moveWidgetsToMainContent(themeData);
  }
}
